import React, { useState } from 'react'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/thumbs/thumbs.min.css'

import './styles.scss'

// import Swiper core and required modules
import SwiperCore, { Navigation, Thumbs } from 'swiper/core'
import { Property } from 'generated/graphql'
import { Image, Skeleton, useMediaQuery } from '@chakra-ui/react'

// install Swiper modules
SwiperCore.use([Navigation, Thumbs])
type Props = {
  property: Property
  loading: boolean
  onClick: (index?: number) => void
}
const ImageGallery: React.FC<Props> = ({ property, loading, onClick }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore | null | undefined>(null)
  const [isMobileOrTable] = useMediaQuery('(max-width: 40em)')
  return (
    <>
      <Swiper
        slidesPerView={1}
        autoHeight={true}
        spaceBetween={10}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        className="singlePropertySwiper"
      >
        {property?.photos?.map((photo, index) => (
          <SwiperSlide key={photo?.id}>
            <Skeleton isLoaded={!loading}>
              <Image
                cursor="pointer"
                onClick={() => onClick(index)}
                borderRadius="xl"
                alt="nsoko property, property image"
                fallback={
                  <Skeleton width="100%" borderRadius="xl" height={{ base: '30vh', md: '56vh' }} />
                }
                src={isMobileOrTable ? photo?.formats?.medium?.url ?? photo?.url : photo?.url}
                fallbackSrc={photo?.formats?.thumbnail?.url}
              />
            </Skeleton>
          </SwiperSlide>
        ))}
      </Swiper>

      <Swiper
        onSwiper={(e: SwiperCore) => setThumbsSwiper(e)}
        spaceBetween={5}
        slidesPerView={6}
        freeMode={true}
        watchSlidesVisibility={true}
        watchSlidesProgress={true}
        className="thumbSwiper"
      >
        {property?.photos?.map((photo) => (
          <SwiperSlide key={photo?.id}>
            <Skeleton maxH="6rem" isLoaded={!loading}>
              <Image
                alt="nsoko property, property image"
                borderRadius="xl"
                fallback={<Skeleton width="100%" height="6rem" borderRadius="xl" />}
                src={photo?.formats?.thumbnail?.url}
                fallbackSrc={photo?.formats?.thumbnail?.url}
              />
            </Skeleton>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  )
}
export default ImageGallery
